import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import ClerkAuth from "@/components/ClerkAuth";
import { StoreProvider } from "@/context/Store";
import { Preloader } from "@/components/Preloader";
import Shell from "@/components/Shell";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import Product from "@/pages/Product";
import Checkout from "@/pages/Checkout";
import Lab from "@/pages/Lab";
import Custom from "@/pages/Custom";
import TryOnStudio from "@/pages/TryOnStudio";
import PaymentResult from "@/pages/PaymentResult";
import Contact from "@/pages/Contact";
import WriteReview from "@/pages/WriteReview";
import ReviewsPage from "@/pages/ReviewsPage";
import Account, { AuthPage, Info } from "@/pages/Account";
import Admin from "@/admin/Admin";

export default function App() {
  return (
    <BrowserRouter>
      <ClerkAuth>
        <StoreProvider>
          <Preloader />
          <Routes>
            <Route path="/admin" element={<Admin />} />
            <Route element={<Shell />}>
              <Route path="/" element={<Home />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/product/:slug" element={<Product />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/lab" element={<Lab />} />
              <Route path="/custom" element={<Custom />} />
              <Route path="/try-on" element={<TryOnStudio />} />
              <Route path="/payment-result" element={<PaymentResult />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/review" element={<WriteReview />} />
              <Route path="/reviews" element={<ReviewsPage />} />
              <Route path="/account" element={<Account />} />
              <Route path="/story" element={<Info story />} />
              <Route path="/info/:page" element={<Info />} />
              <Route path="/sign-in/*" element={<AuthPage />} />
              <Route path="/sign-up/*" element={<AuthPage up />} />
            </Route>
          </Routes>
          <Toaster position="top-center" />
        </StoreProvider>
      </ClerkAuth>
    </BrowserRouter>
  );
}
